import { CamAction, TrackingEvent } from '@hakimo-ui/hakimo/types';

export const FETCH_ALARMS_COUNT_POLLING_INTERVAL = 5000; // 5 seconds
export const FETCH_ALARMS_DELTA_POLLING_INTERVAL = 5000; // 5 seconds

export const CAM_ACTION_TRACKING_EVENT: Record<CamAction, TrackingEvent> = {
  [CamAction.SAFE]: 'unified_monitoring_mark_safe',
  [CamAction.INVESTIGATE]: 'unified_monitoring_investigate',
  [CamAction.ESCALATE]: 'unified_monitoring_escalate',
  [CamAction.RESOLVE_ESCALATION]: 'unified_monitoring_resolve_escalation',
};
